module.exports = __webpack_public_path__ + "img/analyse-num-bg.99424bf3.png";